import React, { useEffect } from "react";
import Map from "./Map";
import InnerHTML from "dangerously-set-html-content";

function Index(props) {
    const navigateTo = (target) => {
        let element = document.querySelector(`#${target}`);

        // loader element
        const loader = document.querySelector(".st-perloader");
        // get loader element display property

        // check if element is loaded and has scroll height

        // make sure element is loaded, else wait
        console.log(element.scrollHeight, loader);
        if (loader?.style?.display == "none" && element) {
            element.scrollIntoView({
                behavior: "smooth",
            });
        } else {
            setTimeout(() => {
                element = document.querySelector(`#${target}`);
                if (loader?.style?.display == "none" && element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        
                    });
                }else{
                    navigateTo(target);
                }
            }, 500);
        }
    };

    useEffect(() => {
        // console.log(props.clinics);
        // get target id from url and scroll to it
        const url = window.location.href;
        const target = url.split("#")[1];
        if (target) {
            navigateTo(target);
        }
    }, []);

    const getDefaultZoom = () => {
        switch (props.country) {
            case "my":
                return 7.5;
                break;
            case "sg":
                return 11;
                break;
            case "id":
                return 4.8;
                break;
            default:
                return 9;
                break;
        }
    };

    return (
        <div>
            <div
                id="home"
                style={{
                    background:
                        "url('/assets/images/health_report_hero_bg.png')",
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                    marginTop: 80,
                }}
                className="jumbotron jumbotron-fluid"
            >
                <div className="container py-5">
                    <div className="row justify-content-center align-items-center">
                        <div className="col text-white">
                            <h2 className="text-white">
                                <b>Elevate Your Oral Health</b> with
                            </h2>
                            <h1 className="text-white font-bold">
                                <b>Intelligent Reports</b>
                            </h1>
                            <p>
                                Our <b>AI-Generated Dental Health Reports</b>{" "}
                                use smart technology to give you personalized
                                insights about your oral health. Get early
                                detection of issues and tailored treatment plan
                                recommendations for a brighter and healthier
                                smile.
                            </p>
                            <div>
                                <a
                                    style={{
                                        borderRadius: 25,
                                        border: "2px solid #FFF",
                                        padding: "0.72em 1.8em",
                                        fontSize: 14,
                                    }}
                                    href="#features"
                                    className="st-btn btn btn-sm btn-outline st-smooth-move text-white mr-2"
                                >
                                    Features
                                </a>
                                <a
                                    style={{
                                        borderRadius: 25,
                                        border: "2px solid #1665d8",
                                    }}
                                    href="#contact"
                                    className="st-btn btn-sm st-style1 st-color1 st-smooth-move"
                                >
                                    Contact Us
                                </a>
                            </div>
                        </div>
                        <div className="d-none d-md-block col text-center">
                            <img
                                style={{ width: "80%" }}
                                src={`/assets/images/Teeth.png`}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div id="about" className="target-id"></div>
            <div className="container py-5">
                <div className="row align-items-center py-5">
                    <div className="col-xs-12 col-md-6 col-lg-4">
                        <h3>
                            <b>About</b> AI-Generated Dental Health Report
                        </h3>
                    </div>
                    <div className="col-xs-12 col-md-6 col-lg-8">
                        <p>
                            AI-generated dental health report provides a
                            comprehensive overview of an individual’s oral
                            health, including the condition of the teeth, gums
                            as well as any diagnosed dental issues. The report
                            serves as a tool for communication between the
                            dentist and the patient, aiding in the understanding
                            of oral health status, treatment plan and preventive
                            measures.
                        </p>
                    </div>
                </div>
            </div>

            <div id="features" className="target-id"></div>
            <div
                style={{
                    background:
                        "transparent linear-gradient(108deg, #01BBCD 0%, #155ED1 100%) 0% 0% no-repeat padding-box",
                }}
            >
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-8">
                            <h3 className="text-white">
                                Our Dental Health Report <b>Includes</b>
                            </h3>
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-md-6 py-2 d-flex align-items-center">
                                        <img
                                            style={{ width: "80px" }}
                                            src={`/assets/images/OPG Xray.svg`}
                                        />
                                        <p className="text-white font-bold px-2">
                                            OPG X-ray Analysis and Explanation
                                        </p>
                                    </div>
                                    <div className="col-12 col-md-6 py-2 d-flex align-items-center">
                                        <img
                                            style={{ width: "80px" }}
                                            src={`/assets/images/Advice.svg`}
                                        />
                                        <span className="text-white font-bold px-2">
                                            Protective Dental Care and Oral
                                            Hygiene Advice
                                        </span>
                                    </div>
                                    <div className="col-12 col-md-6 py-2 d-flex flex-row align-items-center">
                                        <img
                                            style={{ width: "80px" }}
                                            src={`/assets/images/AI tech.svg`}
                                        />
                                        <span className="text-white font-bold px-2">
                                            State-of-the-Art AI Technology
                                        </span>
                                    </div>
                                    <div className="col-12 col-md-6 py-2 d-flex flex-row align-items-center">
                                        <img
                                            style={{ width: "80px" }}
                                            src={`/assets/images/Chart.svg`}
                                        />
                                        <span className="text-white font-bold px-2">
                                            Comprehensive Dental Charting
                                        </span>
                                    </div>
                                    <div className="col-12 col-md-6 py-2 d-flex flex-row align-items-center">
                                        <img
                                            style={{ width: "80px" }}
                                            src={`/assets/images/Visual.svg`}
                                        />
                                        <span className="text-white font-bold px-2">
                                            Detailed Dental Health Report with
                                            Visual Highlights
                                        </span>
                                    </div>
                                    <div className="col-12 col-md-6 py-2 d-flex flex-row align-items-center">
                                        <img
                                            style={{ width: "80px" }}
                                            src={`/assets/images/Expert led.svg`}
                                        />
                                        <span className="text-white font-bold px-2">
                                            Expert Validated Dental Health
                                            Assessment
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <img src="/assets/images/Report.png" />
                        </div>
                    </div>
                </div>
            </div>

            <div
                style={{
                    background:
                        "transparent url('/assets/images/wave BG.svg') 0% 0% no-repeat padding-box",
                }}
                className="py-5"
            >
                <div className="container text-center">
                    <h3>
                        <b>Highlighted</b> in the Report
                    </h3>
                </div>
                <div className="container py-4">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6">
                            <img src="/assets/images/OPG.png" />
                        </div>
                        <div className="col-12 col-md-6">
                            <h5 className="text-primary">
                                AI Orthopantomogram (OPG) Analysis
                            </h5>
                            <p>
                                AI Orthopantomogram (OPG) Analysis in dental
                                field is bolstering diagnostic capabilities and
                                refining treatment planning. The benefits of AI
                                OPG include:
                            </p>
                            <ul>
                                <li>
                                    Improved Accuracy of Diagnostic Assessments
                                </li>
                                <li>
                                    Time Efficiency and Optimised Dentist
                                    Workflow
                                </li>
                                <li>Enhanced Treatment Customization</li>
                                <li>Assistance in Complex Cases</li>
                                <li>Consistency in Analysis</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container py-4">
                    <div className="row align-items-center">
                        <div className="d-md-none col-12 col-md-6">
                            <img src="/assets/images/Dental Chart.png" />
                        </div>
                        <div className="col-12 col-md-6">
                            <h5 className="text-primary">Dental Chart</h5>
                            <p>
                                A dental chart is a systematic and visual
                                representation of a patient’s oral health,
                                providing a detailed record that dentists use
                                for diagnostic, treatment planning, and
                                monitoring purposes. The benefits of dental
                                chart include:
                            </p>
                            <div className="row">
                                <div className="col-6">
                                    <ul>
                                        <li>Visual Representation</li>
                                        <li>Dental History Tracking</li>
                                        <li>Treatment Progress Monitoring</li>
                                    </ul>
                                </div>
                                <div className="col-6">
                                    <ul>
                                        <li>Legal Documentation</li>
                                        <li>Improve Patient Care</li>
                                        <li>Organised Patient Information</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="d-none d-md-block col-12 col-md-6">
                            <img src="/assets/images/Dental Chart.png" />
                        </div>
                    </div>
                </div>

                <div className="container py-4">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6">
                            <img src="/assets/images/Problem Identity.png" />
                        </div>
                        <div className="col-12 col-md-6">
                            <h5 className="text-primary">
                                Infographic on the Problem Identified
                            </h5>
                            <p>
                                Infographics help to highlight specific dental
                                issues identified in the health report, bringing
                                attention to crucial areas that may necessitate
                                focused attention or intervention. It helps to:
                            </p>
                            <ul>
                                <li>
                                    Be a Visual Explanation that Aids
                                    Understanding
                                </li>
                                <li>Highlight Key Issues</li>
                                <li>Simplify Complex Information</li>
                                <li>Be an Effective Communication Tools</li>
                                <li>Improve Patient Engagement</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container py-4">
                    <div className="row align-items-center">
                        <div className="d-md-none col-12 col-md-6">
                            <img src="/assets/images/common treatment.png" />
                        </div>
                        <div className="col-12 col-md-6">
                            <h5 className="text-primary">
                                Infographic on the Common Dental Treatment
                            </h5>
                            <p>
                                Infographic on Common Dental Treatments is a
                                visual representation that provides an overview
                                of frequently administered dental procedures. It
                                is designed to:
                            </p>
                            <ul>
                                <li>Enhance Patient Understanding</li>
                                <li>Provide Time-Efficient Communication</li>
                                <li>Encourage Preventive Measure</li>
                            </ul>
                        </div>
                        <div className="d-none d-md-block col-12 col-md-6">
                            <img src="/assets/images/common treatment.png" />
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="why"
                style={{
                    background:
                        "transparent linear-gradient(108deg, #01BBCD 0%, #155ED1 100%) 0% 0% no-repeat padding-box",
                }}
                className="target-id"
            >
                <div className="container py-5">
                    <div className="text-center pb-4">
                        <h3 className="text-white">Why Choose Us</h3>
                    </div>
                    <div className="row text-white font-bold">
                        <div className="col-6 col-md-4 text-center my-2">
                            <div
                                className="p-2"
                                style={{
                                    border: "1px solid #7BF0FF",
                                    borderRadius: 15,
                                    height: "100%",
                                }}
                            >
                                <div
                                    className="p-4"
                                    style={{
                                        border: "1px dashed #7BF0FF",
                                        borderRadius: 10,
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        style={{ width: 75 }}
                                        src={`/assets/images/fast_result2.svg`}
                                    />
                                    <p>Faster Results</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 text-center my-2">
                            <div
                                className="p-2"
                                style={{
                                    border: "1px solid #7BF0FF",
                                    borderRadius: 15,
                                    height: "100%",
                                }}
                            >
                                <div
                                    className="p-4"
                                    style={{
                                        border: "1px dashed #7BF0FF",
                                        borderRadius: 10,
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        style={{ width: 75 }}
                                        src={`/assets/images/time saving.svg`}
                                    />
                                    <p>Time Saving for Dentists</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 text-center my-2">
                            <div
                                className="p-2"
                                style={{
                                    border: "1px solid #7BF0FF",
                                    borderRadius: 15,
                                    height: "100%",
                                }}
                            >
                                <div
                                    className="p-4"
                                    style={{
                                        border: "1px dashed #7BF0FF",
                                        borderRadius: 10,
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        style={{ width: 75 }}
                                        src={`/assets/images/Consistent.svg`}
                                    />
                                    <p>Consistent and Reliable</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 text-center my-2">
                            <div
                                className="p-2"
                                style={{
                                    border: "1px solid #7BF0FF",
                                    borderRadius: 15,
                                    height: "100%",
                                }}
                            >
                                <div
                                    className="p-4"
                                    style={{
                                        border: "1px dashed #7BF0FF",
                                        borderRadius: 10,
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        style={{ width: 75 }}
                                        src={`/assets/images/Early D.svg`}
                                    />
                                    <p>Early Detection</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 text-center my-2">
                            <div
                                className="p-2"
                                style={{
                                    border: "1px solid #7BF0FF",
                                    borderRadius: 15,
                                    height: "100%",
                                }}
                            >
                                <div
                                    className="p-4"
                                    style={{
                                        border: "1px dashed #7BF0FF",
                                        borderRadius: 10,
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        style={{ width: 75 }}
                                        src={`/assets/images/Personalized R.svg`}
                                    />
                                    <p>Personalized Recommendations</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-4 text-center my-2">
                            <div
                                className="p-2"
                                style={{
                                    border: "1px solid #7BF0FF",
                                    borderRadius: 15,
                                    height: "100%",
                                }}
                            >
                                <div
                                    className="p-4"
                                    style={{
                                        border: "1px dashed #7BF0FF",
                                        borderRadius: 10,
                                        height: "100%",
                                    }}
                                >
                                    <img
                                        style={{ width: 75 }}
                                        src={`/assets/images/Education.svg`}
                                    />
                                    <p>Educational Insights for Patients</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div  className=""></div> */}
            <div id="our-presence" className="container py-5 target-id" style={{
                scrollMarginTop: "60px"
            }}>
                <h3 className="text-center mb-4">
                    <b>Our Presence</b> in Dental Industry
                </h3>
                <InnerHTML html={props.clients_partial} />
                <div
                    className="py-5"
                    style={{ width: "max-content", margin: "auto" }}
                >
                    <div
                        style={{
                            width: "auto",
                            fontSize: "1.5rem",
                            background:
                                "transparent linear-gradient(97deg, #01BBCD 0%, #155ED1 100%) 0% 0% no-repeat padding-box",
                            borderRadius: 20,
                        }}
                        className="px-4 py-2 d-flex align-items-center justify-content-around"
                    >
                        <span className="text-white px-1 px-md-4">
                            <span style={{ color: "#7BF0FF" }}>150+</span>{" "}
                            Clinics
                        </span>
                        <span
                            style={{ color: "#7BF0FF" }}
                            className="px-1 px-md-2"
                        >
                            |
                        </span>
                        <span className="text-white px-1 px-md-4">
                            <span style={{ color: "#7BF0FF" }}>300+</span>{" "}
                            Dentists
                        </span>
                    </div>
                </div>
                <div className="overflow-hidden" style={{ borderRadius: 15 }}>
                    <Map
                        defaultZoom={getDefaultZoom()}
                        position={props.coordinate}
                        clinics={props.clinics}
                        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAfGitWdyztZoGCEvqHkiFq3oW_e5JwPGc"
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div style={{ height: `400px` }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                    />
                </div>
            </div>

            <div
                id="contact"
                style={{
                    background:
                        "transparent linear-gradient(108deg, #01BBCD 0%, #155ED1 100%) 0% 0% no-repeat padding-box",
                    marginTop: "-12rem",
                    paddingTop: "10rem",
                }}
            >
                <div className="container py-5">
                    <div class="card" style={{ borderRadius: 15 }}>
                        <div class="card-body p-5">
                            <h3>Drop Us A Message</h3>

                            <InnerHTML html={props.contact_partial} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;
